export default __webpack_public_path__ + "static/hotel-8bfca41fc96e6744952b1b8d4661c3e6.jpg";